module.exports = __webpack_public_path__ + "img/nursenewphone.45870e1a.png";